import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Breadcrumb/Breadcrumb";

import { Button } from "react-bootstrap";
import useRequest from "../../../hooks/useRequest";
import { toast } from "react-toastify";
import { FaEdit } from "react-icons/fa";
import { FaDeleteLeft } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
import Swal from "sweetalert2";
import Pagination from "../../Pagination/Pagination";
import AddExtraCharge from "./AddExtraCharge";

function List() {
  const { response: responseUpdate, request: requestUpdate } = useRequest();
  const { response: responseDelete, request: requestDelete } = useRequest();

  const { response: responseListResponse, request: requestList } = useRequest();
  const [page, setPage] = useState(1);
  const [totalDocuments, setTotalDocuments] = useState(10);
  const [columns] = useState([
    { title: "Title" },
    { title: "Price" },
    { title: "User Type" },
    { title: "Charge Type" },
    { title: "Tax Percent" },
    { title: "Status" },
    { title: "Action" },
  ]);
  const [data, setData] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [rewardData, setRewardData] = useState({
    title: "",
    chargeType: "",
    userType: "",
    amount: "",
    taxPercent: "",
    status: "",
  });

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleSaveChanges = (data) => {
    // console.log
    if (data?.chargeId) {
      requestUpdate("POST", "admin/extraCharge/updateCharge", data);
    } else {
      requestUpdate("POST", "admin/extraCharge/addCharge", data);
    }
  };

  useEffect(() => {
    requestList("GET", `admin/extraCharge/getAllCharges`, {
      page,
      per_page: 10,
    });
  }, [page]);

  useEffect(() => {
    if (responseUpdate) {
      if (responseUpdate.status) {
        toast.success("Reward has been added successfully.");
      }
      requestList("GET", `admin/extraCharge/getAllCharges`, {
        page,
        per_page: 10,
      });
      handleCloseModal();
    }
  }, [responseUpdate]);

  useEffect(() => {
    if (responseListResponse) {
      if (responseListResponse.status) {
        setData(responseListResponse.data);
        setTotalDocuments(responseListResponse.totalReward);
      }
    }
  }, [responseListResponse]);

  useEffect(() => {
    if (responseDelete) {
      if (responseDelete.status) {
        toast.success("Reward has been deleted successfully.");
        requestList("GET", `admin/extraCharge/getAllCharges`, {
          page,
          per_page: 10,
        });
      }
      handleCloseModal();
    }
  }, [responseDelete]);

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this banner?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(function (result) {
      if (result.value) {
        requestDelete("POST", "admin/extraCharge/deleteCharge", {
          chargeId: id,
        });
      }
    });
  };

  const fetchMoreData = ({ selected }) => {
    setPage(selected + 1);
  };

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb
            title={"Extra Charges"}
            links={[{ to: "/", name: "Home" }]}
          />
          <div className="ms-panel">
            <div className="ms-panel-header">
              <div className="row">
                <div className="col-md-3">
                  <h6>{"Extra Charges"}</h6>
                </div>
                <div className="col-md-7"></div>
                <div className="col-md-2">
                  <div className="form-group">
                    <Button
                      className="btn btn-primary"
                      onClick={handleShowModal}
                    >
                      {" "}
                      Add
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="ms-panel-body">
              <div className="table-responsive">
                <table className="table table-hover thead-primary">
                  <thead>
                    <tr>
                      {columns &&
                        columns.length > 0 &&
                        columns.map((obj) => <th scope="col">{obj?.title}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.length > 0 &&
                      data.map((item, i) => (
                        <tr key={i}>                         
                          <td>{item?.title}</td>
                          <td>{item?.amount}</td>
                          <td>{item?.userType}</td>
                          <td>{item?.chargeType}</td>
                          <td>{item?.taxPercent}</td>
                          <td>{item?.status}</td>
                          <td>
                            <div className="">
                              <span className="cursor-pointer">
                                <FaEdit
                                  fontSize={"20px"}
                                  onClick={() => {
                                    setRewardData({
                                      id: item?._id || "",
                                      title: item?.title || "",
                                      chargeType: item?.chargeType || "",
                                      userType: item?.userType || "",
                                      amount: item?.amount || "",
                                      taxPercent: item?.taxPercent || "",
                                      status: item?.status || "",
                                    });
                                    setShowModal(true);
                                  }}
                                />
                              </span>
                              <span className="cursor-pointer">
                                <MdDelete
                                  fontSize={"20px"}
                                  onClick={() => handleDelete(item?._id)}
                                />
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    {data.length == 0 && (
                      <tr>
                        <td colSpan="7" style={{ textAlign: "center" }}>
                          {" "}
                          No data found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {data && (
                  <Pagination
                    page={page}
                    totalDocuments={Math.ceil(totalDocuments / 10)}
                    getNewData={fetchMoreData}
                    perPage={10}
                    currentDocLength={data.length}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddExtraCharge
        show={showModal}
        handleClose={handleCloseModal}
        handleSave={handleSaveChanges}
        initialData={rewardData}
      />
    </div>
  );
}

export default List;
